<h2 mat-dialog-title>{{ 'ecase.explorer.documentList.rename.title' | translate }}</h2>
<mat-dialog-content>
  <form [formGroup]="renameForm" autocomplete="off">
    <mat-label for="ecase_explorer_rename_new_file_name">
      <span style="color: red">* </span>{{ 'ecase.explorer.documentList.rename.newFileName' | translate }}
    </mat-label>
    <mat-form-field appearance="outline" style="width: 100%;">
      <input [formControlName]="'newFileName'"
             [attr.maxlength]="maxBaseLength"
             autocomplete="off"
             id="ecase_explorer_rename_new_file_name"
             matInput>
      <span *ngIf="suffix" matSuffix>{{ suffix }}</span>
      <mat-error *ngIf="renameForm.controls['newFileName'].errors?.required">
        {{ 'ecase.common.thisfieldismandatory' | translate }}
      </mat-error>
      <mat-error *ngIf="renameForm.controls['newFileName'].errors?.sameName">
        {{ 'ecase.explorer.documentList.rename.sameNameError' | translate }}
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
  <button (click)="onConfirm()" [disabled]="renameForm.invalid || submitting"
          [attr.aria-busy]="submitting"
          class="eCase-dialog-positive-action-button" mat-raised-button
          style="margin-right: 15px;">
    <span class="rename-confirm-content">
      <mat-spinner *ngIf="submitting"
                   [diameter]="20"
                   [attr.aria-label]="('ecase.explorer.documentList.rename.title' | translate) + '…'">
      </mat-spinner>
      <span>{{ 'ecase.common.confirm' | translate }}</span>
    </span>
  </button>
  <button (click)="onClose()" [disabled]="submitting"
          class="eCase-dialog-negative-action-button"
          mat-raised-button>{{ 'ecase.common.close' | translate }}
  </button>
</mat-dialog-actions>